import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export const EventsBasicInfoComponent = ({ onInnerBasicFormChange, selectedEvents, communities, Programs }: any) => {
    const entityType: any = [
        { Description: 'Community', Value: 3 },
        { Description: 'ONEProgramPolicy', Value: 4 },
    ]

    return (
        <><AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                    <InputContainer

                        label="Active"
                        name="IsActive"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsActive'
                            )
                        }}
                        type="checkbox"
                        value={selectedEvents?.IsActive}
                    />

                    <InputContainer

                        label="Enable"
                        name="IsEnable"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsEnable'
                            )
                        }}
                        type="checkbox"
                        value={selectedEvents?.IsEnable}
                    />

                    <InputContainer
                        label="Entity Type"
                        labelField="Description"
                        list={entityType}
                        onValueChange={(event: any, newValue: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'EntityTypeName',
                            );
                        }}
                        optionName='Choose Entity Type'
                        type="select"
                        value={selectedEvents?.EntityTypeName}
                        valueField="Description"
                    />

                    {selectedEvents?.EntityTypeName === "Community" &&
                        <InputContainer
                            label="Community Name"
                            labelField="Name"
                            list={communities}
                            onValueChange={(event: any, newValue: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'EntityId',
                                );
                            }}
                            optionName='Choose communities'
                            type="select"
                            value={selectedEvents?.EntityId}
                            valueField="Id"
                        />}

                    {selectedEvents?.EntityTypeName === "ONEProgramPolicy" &&
                        <InputContainer
                            label="Program Name"
                            labelField="Name"
                            list={Programs}
                            onValueChange={(event: any, newValue: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'EntityId',
                                );
                            }}
                            optionName='Choose Program'
                            type="select"
                            value={selectedEvents?.EntityId}
                            valueField="Id"
                        />}

                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Name'

                            )
                        }}
                        type="text"
                        value={selectedEvents?.Name}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'

                            )
                        }}
                        type="text"
                        value={selectedEvents?.Description}
                    />

                    <InputContainer
                        label="Start Date"
                        name="StartDateUtc"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'StartDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedEvents?.StartDateUtc}
                    />

                    <InputContainer
                        label="End Date"
                        name="EndDateUtc"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'EndDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedEvents?.EndDateUtc}
                    />


                    <InputContainer
                        label="Remarks"
                        name="Remarks"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Remarks'

                            )
                        }}
                        type="text"
                        value={selectedEvents?.Remarks}
                    />


                </div>
            }
            expandedPanel="Basic Info"
            headerTitle="Basic Info"
        />
        </>

    )
}
export default EventsBasicInfoComponent;
